<template>
  <div :qrOrderFlow="qrOrderFlow">
    <div :dependentComputedProps="{ appConfig }"></div>

    <div
      class="user-address-header"
      @click="handleAddressEdit($event)"
      :class="{ hide: !getCurrentStoreFolder }"
    >
      <div>
        <i
          v-bind:style="{ color: modulePropsData?.themeColor }"
          class="fs-13 jfi-location"
        ></i>
        <span
          class="address-alias lh18 bold ml5 mr8 fs-14"
          v-bind:style="{ color: modulePropsData?.themeColor }"
          >{{ topAddressLine }}</span
        >
        <i
          class="jfi-arrow-line"
          v-bind:style="{ color: modulePropsData?.themeColor }"
        ></i>
      </div>
      <span
        class="complete-address lh18"
        v-bind:style="{ color: modulePropsData?.themeColor }"
        >{{ bottomAddressLine }}</span
      >
    </div>

    <!-- Modal fetching location animation -->
    <setting-location-modal
      :location-name="topAddressLine"
      :location-detail="bottomAddressLine"
      :is-location-loading="isLocationLoading"
      v-if="showLocationLoading"
    />

    <!-- Modal while intial session is created -->
    <generic-modal
      v-if="!isSessionPresent"
      :height="locationLoaderModalDim.height"
      :width="locationLoaderModalDim.width"
      :modalClass="locationLoaderModalDim.modalClass"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body> </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <!-- Location permission popup -->
    <generic-modal
      height="100vh"
      width="100vw"
      padding="0px"
      v-if="splashScreenSettled && showLocationPermissionModalShimmer"
    >
      <template v-slot:body>
        <shimmer />
        <generic-modal
          v-if="showLocationPermissionModal"
          :height="menuModalDim.height"
          :width="menuModalDim.width"
          :modalClass="menuModalDim.modalClass"
          :zIndex="vwoVariant === 'nextgen_variant_h' ? '9999' : ''"
          :genericModalSource="'showLocationPermissionModal'"
        >
          <template v-slot:header>
            <div></div>
          </template>
          <template v-slot:body>
            <div class="flex-column location-permission-div">
              <i class="jfi-location fs-14 color-dark-green"></i>
              <p class="fs-14 tc">
                Allow <b class="bold">Domino's</b> to access this <br />
                device's location ?
              </p>
              <div class="disp-col-inline jcsb full mt20">
                <span
                  class="text-cta"
                  @click="handleLocationPermissionModal(false, true)"
                >
                  Ask Later
                </span>
                <button
                  class="btn medium"
                  @click="handleLocationPermissionModal(true, true)"
                >
                  Allow
                </button>
              </div>
            </div>
          </template>
          <template v-slot:footer>
            <div></div>
          </template>
        </generic-modal>
      </template>
    </generic-modal>

    <!--  Modal Location fetched animation -->
    <!--     <generic-modal
      v-if="showLocationFetchedPopup"
      :height="locationLoaderModalDim.height"
      :width="locationLoaderModalDim.width"
      :modalClass="locationLoaderModalDim.modalClass"
    >
      <template v-slot:header>
        <div></div>
      </template>
      <template v-slot:body>
        <div class="setting-location move-effect lft-pos">
          <div>
            <i class="jfi-location fs-52 loc-ico-effect"></i>
            <div
              class="addr-alias bold fs-18 color-primary font-dec-effect-14 tl pl15"
            >
              {{ isTrueLocationDetected ? locationData.address_alias : "..." }}
            </div>
          </div>
          <div class="addr-complete fs-14 color-base font-dec-effect-12">
            {{
              isTrueLocationDetected
                ? locationData.complete_address
                : "Exact location required!"
            }}
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal> -->
    <template v-if="showLocationAccessBlockedModal">
      <location-access-blocked-message></location-access-blocked-message>
    </template>

    <!-- Login modal -->
    <generic-modal
      v-if="showLoginModal"
      @close="closeLoginModal()"
      :height="loginModalDim.height"
      :width="loginModalDim.width"
      :modalClass="loginModalDim.modalClass"
      :genericModalSource="'homeLoginIcon'"
    >
      <template v-slot:header>
        <!-- <i @click="closeSearchModal()" class="jfi-cross sticky-pop-cross"></i> -->
      </template>
      <template v-slot:body>
        <div class="login-modal">
          <div class="login-top">
            <Carousel
              :autoplay="3000"
              :wrap-around="true"
              :pauseAutoplayOnHover="true"
              :mouseDrag="false"
              :touchDrag="false"
              :transition="900"
              :items-to-show="1"
            >
              <Slide v-for="(data, index) in loginModalData" :key="index">
                <div class="login-nudge-img pr">
                  <template v-if="data.imageUrl">
                    <lazy-image
                      :src="staticImgBaseUrl + '/images/global' + data.imageUrl"
                      alt="Login Nudge image"
                    />
                  </template>
                  <div class="dot-flashing-container">
                    <div
                      class="dot-flashing"
                      :class="{ 'active-slide-dot': i == index }"
                      v-for="(m, i) in loginModalData"
                      :key="i"
                    ></div>
                  </div>
                  <div class="domino-logo-img">
                    <lazy-image
                      :src="
                        staticImgBaseUrl + '/images/global' + loginModuleIcon
                      "
                      alt="Domino logo image"
                    />
                  </div>
                </div>
                <div class="login-nudge-desc bold" v-html="data.desc"></div>
              </Slide>
              <template #addons> </template>
            </Carousel>
          </div>
          <div class="login-bottom tc">
            <button class="btn login-cta" @click="gotoLogin()">Login</button
            ><br />
            <span class="color-grey fs-12 mt5" @click="closeLoginModal()"
              >Skip Login</span
            >
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>

    <login-nudge-modal-small
      v-if="
        shouldHideCompleteLoginFlow
          ? false
          : shouldHideLoginPopupVariant || shouldHideLocationAndLoginFlowVariant
            ? false
            : shouldHideLocationPermissionPopupVariant //only hide location flow but show login
              ? true
              : shouldHideCompleteLocationFlow
                ? true
                : isLocationSettled && !showLocationLoading
      "
    ></login-nudge-modal-small>

    <next-gen-loader v-if="showNextGenLoaderModal"></next-gen-loader>
    <alert-popup v-if="showAlertModal"></alert-popup>
  </div>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
</script>

<script>
import { defineAsyncComponent } from "vue";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  keyMapsMutation,
  keyMapsAction,
  keyMapsGetter,
} from "../helpers/storeKeys";
import { getExperimentsPromiseArray } from "../helpers/vwoSetup";
import {
  PWA_WORKSPACE_ID,
  MAIN_ACCOUNT_ID_XLABS,
  TENANT_ID_XLABS,
} from "../helpers/xlabsConstants";
import { launchXlabsSdk } from "xlabs-sdk";
import {
  staticImgBaseUrl,
  projectBasePathWithFolder,
  v2PwaBasePath,
  shouldHideCompleteLocationFlow,
  shouldHideCompleteLoginFlow,
  shouldLoginFlowSkip,
  isCorporateSite,
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import LoginNudgeModalData from "../assets/FallbackData/LoginNudgeModalData.json";
import setEvents, { loadAmplitudeUnsentEvents } from "../helpers/events";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
  VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME,
} from "../config/vwoKeys";
import userActivityTracking from "../helpers/UserActivityTracking";
import PageNames from "../config/pageNames";
import Shimmer from "./Shimmer.vue";
import { initializeMoEngageTime } from "../helpers/moengage";
import Location from "../config/location";
import address from "../helpers/address";
export default {
  name: "HomePageUserAddress",

  components: {
    GenericModal,
    LocationAccessBlockedMessage: defineAsyncComponent(
      () => import("./LocationAccessBlockedMessage.vue"),
    ),
    Carousel,
    Slide,
    LoginNudgeModalSmall: defineAsyncComponent(
      () => import("./LoginNudgeModalSmall.vue"),
    ),
    SettingLocationModal: defineAsyncComponent(
      () => import("./SettingLocationModal.vue"),
    ),
    Shimmer,
    AlertPopup: defineAsyncComponent(() => import("./AlertPopup.vue")),
    NextGenLoader: defineAsyncComponent(() => import("./NextGenLoader.vue")),
  },
  props: ["moduleProps"],
  data() {
    return {
      showMenuModal: false,
      menuModalDim: {
        width: "270px",
        height: "fit-content",
        modalClass: "top-40per",
      },
      staticImgBaseUrl: staticImgBaseUrl,
      showLocationLoadingPopup: false,
      /* showLocationFetchedPopup: false, */
      showLocationPermissionModal: false,
      showLocationPermissionModalShimmer: true,
      isOnStorePage: window.location.href.includes(
        Utility.getCurrentStoreFolder(),
      ),
      locationLoaderModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup search-modal-wrap",
      },
      showLoginModal: false,
      loginModalDim: {
        width: "100vw",
        height: "100vh",
        modalClass: "full-screen-popup login-modal-wrap",
      },
      loginModalData: [],
      loginModuleIcon: "",
      amplitudeTimeSpentIsNotProcessed: true,
      shouldHideCompleteLoginFlow,
      showLocationLoading: false,
      modulePropsData: {},
      splashScreenSettled: false,
      qrOrder: false,
    };
  },

  async mounted() {
    const promise = this.homepageCodeResumePromise;
    if (promise !== null) {
      try {
        const codeResume = await promise;
      } catch (error) {
        console.log("error homepage - ", error);
      }
    }
    this.splashScreenSettled = true;
    Utility.checkQrOrderTimerExpiry();

    let isVwoVariantAvailable = true;
    let vwoVariant = "";

    //encrypting data for old user
    let dataToEncrypt = LocalStorageFunc.getUserData()?.userData;
    let encryptedData = "";

    if (dataToEncrypt && typeof dataToEncrypt === "object") {
      encryptedData = Utility.encryptData(dataToEncrypt);
      let userInfo = LocalStorageFunc.getUserData();
      userInfo.userData = encryptedData;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
    }

    let dataToEncryptForAddress = LocalStorageFunc.getAddressDetail();
    let encryptedDataForAdress = "";

    if (
      dataToEncryptForAddress &&
      typeof dataToEncryptForAddress === "object"
    ) {
      encryptedDataForAdress = Utility.encryptData(dataToEncryptForAddress);
      LocalStorageFunc.setAddressDetail(encryptedDataForAdress);
    }

    const userInfo = LocalStorageFunc.getUserData();

    const { isLoggedIn = false, userId = "" } = userInfo?.headers || {};
    const requestData = {
      PWA_WORKSPACE_ID,
      MAIN_ACCOUNT_ID: MAIN_ACCOUNT_ID_XLABS,
      TENANAT_ID: TENANT_ID_XLABS,
      USER_INFO: { userId, isLoggedIn },
    };
    launchXlabsSdk("prod", requestData);
    let dataToEncryptForUserLocationData =
      LocalStorageFunc.getUserLocationData();
    if (
      dataToEncryptForUserLocationData &&
      typeof dataToEncryptForUserLocationData === "object"
    ) {
      LocalStorageFunc.setUserLocationData(dataToEncryptForUserLocationData);
    }

    await Promise.all([...getExperimentsPromiseArray()])
      .then((data) => {
        let __ = document.getElementsByClassName("pg-wrapper");
        if (__?.length > 0) {
          let ___ = {};

          data.forEach((element) => {
            for (let key in element) {
              if (key && element[key]) {
                __[0].classList.add(
                  `${key.replace(/\s/g, "")}-${element[key]}`,
                );
              }
              ___[key] = element[key];
            }
          });

          if (
            !Utility.checkNextgenVariant(___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT])
          ) {
            isVwoVariantAvailable = false;
            LocalStorageFunc.unsetSessionStorageKey("nextgenhomepage");
            window.location.href = v2PwaBasePath + Utility.getUrlQueryString();
            return;
          }
          vwoVariant = ___[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
          this.$store.commit(keyMapsMutation.UPDATE_VWO_EXPERIMENTS, ___);
        }
      })
      .catch((errors) => {
        console.error(errors);
      });
    this.modulePropsData = this.moduleProps || {};
    Utility.initializeUtmAttributes();
    loadAmplitudeUnsentEvents(vwoVariant);
    Utility.promoAppliedFromCartPage();

    let exp = this.$store.state.Config.vwoExperiments;
    if (Utility.checkNextgenVariant(exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT])) {
      setEvents("amplitude", "pageView", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
        Page_Name: PageNames.NEXTGEN_HOMEPAGE,
        Previous_page: document.referrer,
      });
      setEvents("amplitude", "nextgenPwaAb", {
        [VWO_VARIANT_NEXTGEN_HOMEPAGE_HEADER_NAME]:
          exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT],
      });

      let landingPage = Utility.tryJsonParse(
        sessionStorage.LANDING_PAGE_FOR_NEXTGEN,
      );
      if (landingPage == "/") {
        landingPage = "home";
      }
      try {
        landingPage =
          landingPage?.trim()?.replace(/^\/+/, "")?.replace(/\/+$/, "") ||
          "home";
      } catch (e) {
        landingPage = "home";
      }
      setEvents("amplitude", "nghUserURL", {
        Page_Name: PageNames.NEXTGEN_HOMEPAGE,
        Previous_page: document.referrer,
        url: window.location.href,
        landingPage: landingPage,
      });
    }

    const linkRewrite = Utility.getLinkRewriteFromSiteprops();
    if (
      linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME ||
      linkRewrite === PageNames.NEXTGEN_LINKREWRITE_HOME_GUEST
    ) {
      LocalStorageFunc.setSessionStorageKey("previousLinkRewrite", linkRewrite);
    } else {
      LocalStorageFunc.unsetSessionStorageKey("previousLinkRewrite");
    }
    this.hidePageLoader();
    if (Utility.shouldRedirectToCategory()) {
      window.location.href =
        projectBasePathWithFolder +
        Utility.getCurrentStoreFolder() +
        LocalStorageFunc.storeId() +
        Utility.getUrlQueryString();
      return;
    }

    //this.checkShowLoginModal();
    /*     if (LocalStorageFunc.isMiniAppPaytmGpay()) {
      LocalStorageFunc.unsetSessionStorageKey("nextgenhomepage");
      window.location.href =
        v2PwaBasePath + "?utm_source=" + LocalStorageFunc.isMiniAppPaytmGpay();
    } else {
      localStorageFunc.setNextGenKeyInSession();
    } */

    if (isVwoVariantAvailable) {
      LocalStorageFunc.setNextGenKeyInSession();
    }

    /* this.locationAnimation(); */
    this.loginModalData = LoginNudgeModalData?.data
      ? LoginNudgeModalData?.data
      : [];
    this.loginModuleIcon = LoginNudgeModalData?.logoUrl
      ? LoginNudgeModalData?.logoUrl
      : "";
    window.addEventListener("online", function () {
      // console.log("online");
    });
    window.addEventListener("offline", function () {
      // console.log("offline");
    });

    this.startupAppiCallsWrapper(() => {
      if (
        (!LocalStorageFunc.isLoggedIn() &&
          !LocalStorageFunc.getSessionStorageValuePwaV2Keys(
            "LOGIN_FLOW_SKIP",
          ) &&
          shouldLoginFlowSkip &&
          !isCorporateSite &&
          !this.qrOrder) ||
        (isCorporateSite && !this.isCorporateLoggedId)
      ) {
        const loginPageUrl = `/${window?._siteProps_?.props?.postorderUIBasepath}login`;
        this.$store.commit(keyMapsMutation.REMOVE_LOYALTY_CART_ITEMS, null);
        window.location.href =
          `${v2PwaBasePath}${loginPageUrl}` + Utility.getUrlQueryString();
      } else {
      if (!LocalStorageFunc.cartId()) {
        this.$store.dispatch(keyMapsAction.ANONYMOUS_USER_API, {
          startupAppiCalls: () => {
            this.startupAppiCalls();
          },
        });
      } else {
        this.startupAppiCalls();
      }
      }
    });
    this.scrollToCategoryId();

    Utility.pizzaCounter();
    setTimeout(() => {
      initializeMoEngageTime();
    }, 5000);
    this.$store.dispatch(keyMapsAction.PIZZA_TOPPING_API, {}, { root: true });

    const isMiniApp = Utility.getMiniAppStorageVal();
    let userData = LocalStorageFunc.getUserData()?.userData;
    if (userData && typeof userData === "string") {
      userData = Utility.decryptData(userData);
    }
    // const userId = userData?.userId || "";
    if (LocalStorageFunc.isLoggedIn() && userId && !isMiniApp) {
      address.getSavedAddress({ userId: userId });
    }

    if ("scrollRestoration" in history) {
      history.scrollRestoration = "manual";
    }
    window.addEventListener("popstate", function (event) {
      if (window.scrollY !== 0) {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
        history.pushState(null, null, window.location.href);
      } else {
        history.back();
      }
    });
    Utility.setSessionStorageValue(
      "nextgenMenuCategory",
      Utility.getMenuCategory(),
    );
    history.pushState(null, null, window.location.href);
  },

  methods: {
    isMenuSequencingEnabled() {
      return window?._siteProps_?.props?.enableMenuSequencing === "true";
    },
    scrollToCategoryId() {
      let queryParams = Utility.getQueryFromUrl();
      const menuCategory =
        queryParams["scrollTo"] ||
        queryParams["cat_id"] ||
        queryParams["categoryId"] ||
        "";
      if (menuCategory !== "") {
        setTimeout(() => {
          if (menuCategory === "menuTop") {
            Utility.scrollUptoMenuTop();
          } else {
            Utility.scrollUptoTo("element_catg_" + menuCategory);
          }
        }, 0);
      } else {
        Utility.scrollToFromSessionKey();
      }
    },
    logNghLocationEvent(type) {
      const preEventObj = {
        locationType: type,
        storeID: LocalStorageFunc.storeId(),
      };
      const eventObj = Utility.amplitudeEventObj(
        "nghLocation",
        undefined,
        undefined,
        preEventObj,
      );
      setEvents("amplitude", "nghLocation", eventObj);
    },
    eventFunction(
      isClicked = false,
      eObj = "",
      popUpVisible = false,
      popUpVisibleVal = "",
    ) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = {
        ...eObj,
      };

      if (popUpVisible) {
        userAction = popUpVisibleVal ? "allow" : "ask later";
        const eventObj = Utility.amplitudeEventObj(
          userAction,
          undefined,
          undefined,
          preEventObj,
        );
        setEvents("amplitude", "location_permission_on_home", eventObj);
      } else {
        preEventObj["loginStatus"] = this.isLoggedIn ? "yes" : "no";

        const eventObj = Utility.amplitudeEventObj(
          userAction,
          "topbar",
          "1",
          preEventObj,
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    hidePageLoader() {
      document.getElementById("pageLoader").style.display = "none";
    },
    checkShowLoginModal() {
      var loginSkippedStatus = Utility.getCookie("Login_skipped");
      LocalStorageFunc.isLoggedIn()
        ? ((this.showLoginModal = false),
          userActivityTracking.pageView(0, "homePageViewed"),
          userActivityTracking.loginStatus(0))
        : loginSkippedStatus == "true"
          ? (this.showLoginModal = false)
          : (this.showLoginModal = true);
      return this.showLoginModal;
    },
    /*     locationAnimation() {
      if (
        window.location.href.includes(Utility.getCurrentStoreFolder()) &&
        !window.location.href.includes(
          Utility.getCurrentStoreFolder() + Location.defaultStoreId
        ) &&
        !LocalStorageFunc.getLocationAnimationKey()
      ) {
        LocalStorageFunc.setLocationAnimationKey(true);
        this.showLocationFetchedPopup = true;
      }
      setTimeout(this.closeLocationFetchedPopup, 1600);
    }, */
    /*     closeLocationFetchedPopup() {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showLocationFetchedPopup = false;
    }, */
    handleAddressEdit() {
      this.eventFunction(true, {
        category: "location",
        subCategory: "location",
      });
      userActivityTracking.location(0);
      let deliveryType = LocalStorageFunc.getDeliveryType();
      let redirectUrl = `${window?._siteProps_?.props?.postorderUIBasepath}searchAddress?deliveryType=${deliveryType}`;
      if (Utility.checkIfOrderTypeNonDelivery(deliveryType)) {
        redirectUrl = Utility.redirectUrlForNonDeliveryOrderType(
          this.isTrueLocationDetected,
          deliveryType,
        );
      }
      window.location.href = `${v2PwaBasePath}/${redirectUrl}&isFromHome=true`;
    },
    startupAppiCallsWrapper(inputFunc) {
      if (navigator.permissions) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then((PermissionStatus) => {
            if (PermissionStatus.state == "granted") {
              LocalStorageFunc.setIsLocationPermissionGiven();
              this.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                true,
              );
              //console.log("allowed")
            } else if (PermissionStatus.state == "prompt") {
              //console.log("prompt");
              this.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false,
              );
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
            } else {
              //console.log("denied");
              this.$store.commit(
                keyMapsMutation.UPDATE_IS_LOCATION_PERMISSION_GIVEN,
                false,
              );
              LocalStorageFunc.unsetKey("isLocationPermissionGiven");
            }
            inputFunc();
          });
      } else {
        inputFunc();
      }
    },
    locationCalls() {
      if (
        window.location.href.includes(Utility.getCurrentStoreFolder()) ||
        Utility.checkIfDefaultStoreId()
      ) {
        let payload = LocalStorageFunc.getCoordsFromRecentLocation();
        if (payload) {
          payload.source = LocalStorageFunc.getLocationSource();
        }
        if (LocalStorageFunc.getDeliveryType() != "D" && payload?.storeId) {
          this.showLocationPermissionModalShimmer = false;
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
            false,
          );
          this.$store.dispatch(keyMapsAction.UPDATE_CACHED_STORE_DATA, payload);
        } else if (payload?.source == "ip") {
          if (LocalStorageFunc.getHideLocationPopupOnceFromSession()) {
            this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
            this.showLocationPermissionModalShimmer = false;
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
              false,
            );
            LocalStorageFunc.unsetSessionStorageKey("hideLocationPopupOnce");
          } else {
            this.showLocationPermissionModal = true;
            this.showLocationPermissionModalShimmer = true;
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
              true,
            );
            document.body.classList.add("body-stop-scroll-mobile");
            if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
              this.handleLocationPermissionModal(true);
            } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
              this.handleLocationPermissionModal(false);
            }
          }
        } else if (
          payload?.storeId &&
          LocalStorageFunc.isLocationSelectedFromPwaV2()
        ) {
          this.showLocationPermissionModalShimmer = false;
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
            false,
          );
          this.$store.dispatch(keyMapsAction.UPDATE_CACHED_STORE_DATA, payload);
        } else {
          if (
            !shouldHideCompleteLocationFlow &&
            !this.shouldHideLocationPermissionPopupVariant &&
            !this.shouldHideLocationAndLoginFlowVariant &&
            !this.qrOrder
          ) {
            this.showLocationPermissionModal = true;
            this.showLocationPermissionModalShimmer = true;
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
              true,
            );
            document.body.classList.add("body-stop-scroll-mobile");
            if (LocalStorageFunc.getIsLocationPermisssionGiven()) {
              this.handleLocationPermissionModal(true);
            } else if (LocalStorageFunc.getAskLocationLaterFromSession()) {
              this.handleLocationPermissionModal(false);
            }
          } else {
            this.showLocationPermissionModalShimmer = false;
            this.$store.commit(
              keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
              false,
            );
            if (this.qrOrder) {
              return;
            }
            this.$store.dispatch(
              keyMapsAction.LOAD_RECENT_LOCATION_FROM_LOCAL_STORAGE,
            );
          }
        }
      } else {
        window.location.href =
          projectBasePathWithFolder +
          Utility.getCurrentStoreFolder() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
      }
    },
    startupAppiCalls() {
      /*       if (this.checkShowLoginModal()) {
        return;
      } */
      this.$store.dispatch(keyMapsAction.LOAD_LOGIN_STATUS, {});
      this.$store.commit(keyMapsMutation.LOAD_CURRENT_ORDER_TYPE, {});
      const coords = LocalStorageFunc.getCoordsFromRecentLocation();
      if (
        this.currentOrderType === "D" &&
        LocalStorageFunc.storeId() === Location.defaultStoreId
      ) {
        this.logNghLocationEvent("default");
      }
      if (coords) {
        coords.source = LocalStorageFunc.getLocationSource();
      }
      if (Utility.isStoreUrlCacheEligible() && coords?.storeId) {
        this.showLocationPermissionModal = false;
        this.showLocationPermissionModalShimmer = false;
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
          false,
        );
        this.$store.commit(keyMapsMutation.UPDATE_IS_LOCATION_SETTLED, {});
        this.$store.dispatch(keyMapsAction.UPDATE_CACHED_STORE_DATA, coords);
      } else {
        this.locationCalls();
      }
      LocalStorageFunc.isLoggedIn() &&
        this.$store.dispatch(keyMapsAction.LOYALITY_API);
      LocalStorageFunc.isLoggedIn() &&
        this.$store.dispatch(keyMapsAction.WALLET_BALANCE_API);
      this.$store.dispatch(keyMapsAction.WELCOME_OFFER_API, {});
      this.$store.dispatch(keyMapsAction.PERSONALIZATION_API, {}).then(() => {
        this.$store.commit(
          keyMapsMutation.UPDATE_CART_FROM_LOCAL_STORAGE,
          this.$store.state.ProductItems.unfilteredProductItems,
        );
      });

      let exp = this.$store.state.Config.vwoExperiments;
      if (
        this.isMenuSequencingEnabled() &&
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
          VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_R
      ) {
        this.$store.dispatch(keyMapsAction.MENU_SEQUENCING_API, {});
      }

      /* this.$store.dispatch(keyMapsAction.LEFT_MENU_API, {}); */
    },
    handleLocationPermissionModal(value, popUpVisible = false) {
      this.showLocationLoadingPopup = true;
      if (value) {
        this.$store.dispatch(keyMapsAction.DETECT_GEO_LOCATION_POPUP, {
          source: "locationPopup",
          showModalM: () => this.showModalM(),
        });
      } else {
        LocalStorageFunc.setAskLocationLaterInSession();
        this.$store.dispatch(keyMapsAction.GOOGLE_GEO_LOCATION_API, {});
      }
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showLocationPermissionModal = false;
      this.showLocationPermissionModalShimmer = false;
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
        false,
      );
      if (popUpVisible) {
        if (value) {
          this.eventFunction(
            true,
            {
              eventCategory: "location permission on home screen",
            },
            true,
            value,
          );
        } else {
          this.eventFunction(
            true,
            {
              eventCategory: "location permission on home screen",
            },
            true,
            value,
          );
        }
      }
    },
    showModalM() {
      this.$store.commit(
        keyMapsMutation.UPDATE_SHOW_LOCATION_ACCESS_BLOCKED_MODAL,
        true,
      );
      if (shouldHideCompleteLocationFlow) {
        this.showLocationLoadingPopup = false;
      }
    },
    closeLoginModal() {
      let domain = Utility.getDomain();
      Utility.setCookie("Login_skipped", true, 1, domain);
      if (window.location.href.includes(Utility.getCurrentStoreFolder())) {
        window.location.reload();
      } else {
        window.location.href =
          projectBasePathWithFolder +
          Utility.getCurrentStoreFolder() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
      }
      userActivityTracking.pageView(0, "homePageViewed");
      userActivityTracking.loginStatus(0);
    },
    gotoLogin() {
      window.location.href = `${v2PwaBasePath}/login`;
    },
    getTimeSpentEventFireTime() {
      return window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime
        ? window?._siteProps_?.props?.amplitudeTimeSpentEventFireTime
        : "3";
    },
    getQrAddresDefaultTitle() {
      return this.modulePropsData?.qrAddressText || "At store";
    },
  },
  computed: {
    homepageCodeResumePromise() {
      const promise = this.$store.state.DynamicWidget.homepageCodeResumePromise;
      return promise;
    },
    appConfig() {
      if (this.amplitudeTimeSpentIsNotProcessed) {
        this.amplitudeTimeSpentIsNotProcessed = false;
        let eventFireTime = this.getTimeSpentEventFireTime();
        setTimeout(() => {
          setEvents("amplitude", "time_spent", {
            eventCategory: "time spent",
            fired_after: eventFireTime,
            Events_time_stamp: new Date().getTime(),
            Page_Name: PageNames.NEXTGEN_HOMEPAGE,
          });
        }, eventFireTime * 1000); //time in milliseconds
      }
    },
    showLocationAccessBlockedModal() {
      return this.$store.state.Location.showLocationAccessBlockedModal;
    },
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    isSessionPresent() {
      let _ =
        this.$store.state.Auth.isLoggedIn ||
        this.$store.state.Auth.isSessionPresent;
      return _;
    },
    locationData() {
      return this.$store.state.Location.locationData;
    },
    isTrueLocationDetected() {
      return this.$store.state.Location.isTrueLocationDetected;
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    storeNotFound() {
      return this.$store.state.Location.storeNotFound;
    },
    isLocationSettled() {
      return this.$store.state.Location.isLocationSettled;
    },
    vwoVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      return exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT];
    },
    isNearestStoreApiSuccess() {
      return this.$store.state.Location.isNearestApiSuccessful;
    },
    nearestApiTopAddress() {
      return this.$store.state.Location.nearestApiTopAddress;
    },
    hideLocationLoadingPopup() {
      this.showLocationLoadingPopup = false;
    },
    isLocationLoading() {
      return (
        this.$store.state.Location.showLocationLoading ||
        (!this.isLocationSettled &&
          this.showLocationLoadingPopup &&
          !Utility.isStoreUrlCacheEligible())
      );
    },
    shouldHideLocationPermissionPopupVariant() {
      //only hide location flow but show login
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_H
      ) {
        return true;
      } else {
        return false;
      }
    },
    shouldHideLoginPopupVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_G
      ) {
        return true;
      } else {
        return false;
      }
    },
    shouldHideLocationAndLoginFlowVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_I
      ) {
        return true;
      } else {
        return false;
      }
    },
    getCurrentStoreFolder() {
      let exp =
        this.$store.getters[keyMapsGetter.GET_CURRENT_STORE_FOLDER_CONFIG];
      return true; //data not coming from VWO. Hence computed property not triggering
      return window.location.href.includes(exp);
    },
    topAddressLine() {
      return this.currentOrderType !== "D" ||
        this.isTrueLocationDetected ||
        LocalStorageFunc.isLocationSelectedFromPwaV2()
        ? this.locationData.address_alias ||
            (this.qrOrder ? this.getQrAddresDefaultTitle() : "No Location")
        : this.nearestApiTopAddress || "No Location";
    },
    bottomAddressLine() {
      return this.currentOrderType !== "D" ||
        this.isTrueLocationDetected ||
        LocalStorageFunc.isLocationSelectedFromPwaV2()
        ? this.locationData.complete_address
        : "Exact Location Required!";
    },
    showAlertModal() {
      return this.$store.state.DynamicWidget.showAlertModal;
    },
    showNextGenLoaderModal() {
      return this.$store.state.DynamicWidget.showLoaderModal;
    },
    isCorporateLoggedId() {
      return this.corporateUserInfo?.headers?.isCorporateLoggedIn || false;
    },
    corporateUserInfo() {
      return LocalStorageFunc.getCorporateUserInfo();
    },
    qrOrderFlow() {
      const qrOrder = this.$store.state.Auth.qrOrder;
      this.qrOrder = qrOrder;
      if (qrOrder) {
        this.showLocationPermissionModalShimmer = false;
      }

      return qrOrder;
    },
  },
  watch: {
    isLocationLoading(newVal, prevVal) {
      if (newVal && !prevVal) {
        this.showLocationLoading = true;
        this.$store.commit(
          keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
          true,
        );
        document.body.classList.add("body-stop-scroll-mobile");
      } else if (!newVal && prevVal) {
        setTimeout(() => {
          this.showLocationLoading = false;
          this.$store.commit(
            keyMapsMutation.UPDATE_SHOW_LOCATION_PERMISSION_MODAL_SHIMMER_STORE,
            false,
          );
          document.body.classList.remove("body-stop-scroll-mobile");
        }, 2000);
      }
    },
  },
};
</script>

<style scoped></style>
